export default __webpack_public_path__ + "static/media/dashboardSelected.b53e149d.svg";